class TabList extends HTMLUListElement {
  constructor() {
    super();

    this.controls.forEach((button) => button.addEventListener('click', this.handleButtonClick.bind(this)));
  }

  get controls() {
    return this._controls = this._controls || Array.from(this.querySelectorAll('[aria-controls]'));
  }

  handleButtonClick(event) {
    event.preventDefault();

    this.controls.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');

      const panel = document.getElementById(button.getAttribute('aria-controls'));
      panel?.removeAttribute('open');
    });

    const target = event.currentTarget;
    target.setAttribute('aria-expanded', 'true');

    const panel = document.getElementById(target.getAttribute('aria-controls'));
    panel?.setAttribute('open', '');
  }

  reset() {
    const firstControl = this.controls[0];
    firstControl.dispatchEvent(new Event('click'));
  }
}
customElements.define('tab-list', TabList, { extends: 'ul' });

class CartDrawer extends DrawerElement {
  constructor() {
    super();
  }

  get shouldAppendToBody() {
    return false;
  }

  get recentlyViewed() {
    return this.querySelector('recently-viewed');
  }

  get tabList() {
    return this.querySelector('[is="tab-list"]');
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('cart:bundled-sections', this.onPrepareBundledSections.bind(this));
    if (this.recentlyViewed) {
      this.recentlyViewed.addEventListener('is-empty', this.onRecentlyViewedEmpty.bind(this));
    }
  }

  onPrepareBundledSections(event) {
    event.detail.sections.push(theme.utils.sectionId(this));
  }

  onRecentlyViewedEmpty() {
    this.recentlyViewed.innerHTML = `
    <div class="drawer__scrollable relative flex justify-center items-start grow shrink text-center">
      <div class="drawer__empty grid gap-5 md:gap-8">
        <h2 class="drawer__empty-text heading leading-none tracking-tight">${theme.strings.recentlyViewedEmpty}</h2>
      </div>
    </div>
    `;
  }

  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);

    if (this.tabList) {
      this.tabList.reset();

      if (this.open) {
        theme.a11y.trapFocus(this, this.focusElement);
        // console.log("drawerrr opennnnn");
        setTimeout(() => {
          this.logWrapper();
        }, 1000);
      }
    }
  }

  logWrapper() {
    // Target the complementary products container
    const complementaryContainer = document.querySelector('.custom-cart__complementary-products');
    const wrapper = document.querySelector('.horizontal-products');
    
    // console.log('Complementary products container:', complementaryContainer);
    // console.log('Horizontal products wrapper:', wrapper);
    
    if (wrapper && complementaryContainer) {
      // console.log('Wrapper found with classes:', wrapper.className);
      // console.log('Wrapper children count:', wrapper.children.length);
      // console.log('Container classes:', complementaryContainer.className);
      
      // Set up scroll progress tracking
      this.setupScrollProgress(wrapper);
    } else {
      console.log('Required elements not found - wrapper:', !!wrapper, 'container:', !!complementaryContainer);
    }
  }

  setupScrollProgress(wrapper) {
    // Target the progress bar elements
    const progressBar = document.querySelector('.complementary-products__progress');
    const progressFill = document.querySelector('.complementary-products__progress-fill');
    
    if (!progressFill) {
      // console.log('Progress bar fill element not found');
      return;
    }
    
    if (!progressBar) {
      // console.log('Progress bar container not found');
      return;
    }

    // console.log('Progress bar elements found:', { progressBar, progressFill });

    // Update progress on scroll
    wrapper.addEventListener('scroll', () => {
      // console.log("in scroll");
      this.updateScrollProgress(wrapper, progressFill);
    });

    // Wait a bit for layout to settle, then update initial progress
    setTimeout(() => {
      // console.log("after wait");
      this.updateScrollProgress(wrapper, progressFill);
    }, 100);
    
    // console.log('Scroll progress tracking set up successfully');
  }

  updateScrollProgress(wrapper, progressFill) {
    const scrollLeft = wrapper.scrollLeft;
    const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
    const clientWidth = wrapper.clientWidth;
    const scrollWidth = wrapper.scrollWidth;
    const totalProducts = wrapper.children.length;
    
    // Check if scrolling is possible
    if (scrollWidth > clientWidth) {
      // Calculate initial progress (how many products are viewable)
      const initialProgress = this.calculateInitialProgress(wrapper);
      
      if (scrollLeft > 0) {
        // User is scrolling - calculate progress from initial position
        const scrollProgress = (scrollLeft / maxScrollLeft) * (100 - initialProgress);
        const totalProgress = initialProgress + scrollProgress;
        
        progressFill.style.width = `${totalProgress}%`;
        // console.log(`Total progress: ${totalProgress.toFixed(1)}% (Initial: ${initialProgress.toFixed(1)}% + Scroll: ${scrollProgress.toFixed(1)}%)`);
      } else {
        // At the beginning - show initial progress
        progressFill.style.width = `${initialProgress}%`;
        // console.log(`Initial progress (viewable products): ${initialProgress.toFixed(1)}%`);
      }
    } else {
      // No scrolling needed, all content is visible
      progressFill.style.width = '100%';
      // console.log('No scrolling needed, all content visible');
    }
  }

  calculateInitialProgress(wrapper) {
    const clientWidth = wrapper.clientWidth;
    const scrollWidth = wrapper.scrollWidth;
    const totalProducts = wrapper.children.length;
    
    if (totalProducts === 0) return 0;
    
    // Calculate how many products are currently viewable
    const viewableProducts = clientWidth / (scrollWidth / totalProducts);
    
    // Calculate initial progress (how much of the total scrollable area is initially visible)
    const initialProgress = (viewableProducts / totalProducts) * 100;
    
    // console.log("Initial Progress Calculation:");
    // console.log("viewableProducts:", viewableProducts);
    // console.log("initialProgress:", initialProgress);
    
    // Cap the progress at 100%
    return Math.min(initialProgress, 100);
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartRemoveButton extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.getAttribute('data-index'), 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton, { extends: 'a' });

class CartItems extends HTMLElement {
  cartUpdateUnsubscriber = undefined;

  constructor() {
    super();

    this.addEventListener('change', theme.utils.debounce(this.onChange.bind(this), 300));
    this.cartUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    // this.updateQuantity(event.target.getAttribute('data-index'), event.target.value, document.activeElement.getAttribute('name'), event.target);
    this.validateQuantity(event);
  }

  onCartUpdate(event) {
    if (event.cart.errors) {
      this.onCartError(event.cart.errors, event.target);
      return;
    }

    const sectionToRender = new DOMParser().parseFromString(event.cart.sections[this.sectionId], 'text/html');

    const miniCart = document.querySelector(`#MiniCart-${this.sectionId}`);
    if (miniCart) {
      const updatedElement = sectionToRender.querySelector(`#MiniCart-${this.sectionId}`);
      if (updatedElement) {
        miniCart.innerHTML = updatedElement.innerHTML;
      }
    }

    const mainCart = document.querySelector(`#MainCart-${this.sectionId}`);
    if (mainCart) {
      const updatedElement = sectionToRender.querySelector(`#MainCart-${this.sectionId}`);
      if (updatedElement) {
        mainCart.innerHTML = updatedElement.innerHTML;
      }
      else {
        mainCart.closest('.cart').classList.add('is-empty');
        mainCart.remove();
      }
    }

    const lineItem = document.getElementById(`CartItem-${event.line}`) || document.getElementById(`CartDrawer-Item-${event.line}`);
    if (lineItem && lineItem.querySelector(`[name="${event.name}"]`)) {
      theme.a11y.trapFocus(mainCart || miniCart, lineItem.querySelector(`[name="${event.name}"]`));
    }
    else if (event.cart.item_count === 0) {
      miniCart
        ? theme.a11y.trapFocus(miniCart, miniCart.querySelector('a'))
        : theme.a11y.trapFocus(document.querySelector('.empty-state'), document.querySelector('.empty-state__link'));
    }
    else {
      miniCart
        ? theme.a11y.trapFocus(miniCart, miniCart.querySelector('.horizontal-product__title'))
        : theme.a11y.trapFocus(mainCart, mainCart.querySelector('.cart__item-title'));
    }

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: event.cart
      }
    }));

    // console.log("cartUpdate calleddd");
    
    // Initialize complementary products after cart update
    setTimeout(() => {
      this.initComplementaryProducts();
    }, 1000);
    
    // Also try after a longer delay as fallback
    setTimeout(() => {
      this.logWrapper();
    }, 3000);
  }

  logWrapper() {
    // Target the complementary products container
    const complementaryContainer = document.querySelector('.custom-cart__complementary-products');
    const wrapper = document.querySelector('.horizontal-products');
    
    // console.log('Complementary products container:', complementaryContainer);
    // console.log('Horizontal products wrapper:', wrapper);
    
    if (wrapper && complementaryContainer) {
      // console.log('Wrapper found with classes:', wrapper.className);
      // console.log('Wrapper children count:', wrapper.children.length);
      // console.log('Container classes:', complementaryContainer.className);
      
      // Set up scroll progress tracking
      this.setupScrollProgress(wrapper);
    } else {
      // console.log('Required elements not found - wrapper:', !!wrapper, 'container:', !!complementaryContainer);
    }
  }

  setupScrollProgress(wrapper) {
    // Target the progress bar elements
    const progressBar = document.querySelector('.complementary-products__progress');
    const progressFill = document.querySelector('.complementary-products__progress-fill');
    
    if (!progressFill) {
      // console.log('Progress bar fill element not found');
      return;
    }
    
    if (!progressBar) {
      // console.log('Progress bar container not found');
      return;
    }

    // console.log('Progress bar elements found:', { progressBar, progressFill });

    // Update progress on scroll
    wrapper.addEventListener('scroll', () => {
      // console.log("in scroll");
      this.updateScrollProgress(wrapper, progressFill);
    });

    // Wait a bit for layout to settle, then update initial progress
    setTimeout(() => {
      // console.log("after wait");
      this.updateScrollProgress(wrapper, progressFill);
    }, 100);
    
    // console.log('Scroll progress tracking set up successfully');
  }

  updateScrollProgress(wrapper, progressFill) {
    const scrollLeft = wrapper.scrollLeft;
    const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
    const clientWidth = wrapper.clientWidth;
    const scrollWidth = wrapper.scrollWidth;
    const totalProducts = wrapper.children.length;
    
    // Check if scrolling is possible
    if (scrollWidth > clientWidth) {
      // Calculate initial progress (how many products are viewable)
      const initialProgress = this.calculateInitialProgress(wrapper);
      
      if (scrollLeft > 0) {
        // User is scrolling - calculate progress from initial position
        const scrollProgress = (scrollLeft / maxScrollLeft) * (100 - initialProgress);
        const totalProgress = initialProgress + scrollProgress;
        
        progressFill.style.width = `${totalProgress}%`;
        // console.log(`Total progress: ${totalProgress.toFixed(1)}% (Initial: ${initialProgress.toFixed(1)}% + Scroll: ${scrollProgress.toFixed(1)}%)`);
      } else {
        // At the beginning - show initial progress
        progressFill.style.width = `${initialProgress}%`;
        // console.log(`Initial progress (viewable products): ${initialProgress.toFixed(1)}%`);
      }
    } else {
      // No scrolling needed, all content is visible
      progressFill.style.width = '100%';
      // console.log('No scrolling needed, all content visible');
    }
  }

  calculateInitialProgress(wrapper) {
    const clientWidth = wrapper.clientWidth;
    const scrollWidth = wrapper.scrollWidth;
    const totalProducts = wrapper.children.length;
    
    if (totalProducts === 0) return 0;
    
    // Calculate how many products are currently viewable
    const viewableProducts = clientWidth / (scrollWidth / totalProducts);
    
    // Calculate initial progress (how much of the total scrollable area is initially visible)
    const initialProgress = (viewableProducts / totalProducts) * 100;
    
    // console.log("Initial Progress Calculation:");
    // console.log("viewableProducts:", viewableProducts);
    // console.log("initialProgress:", initialProgress);
    
    // Cap the progress at 100%
    return Math.min(initialProgress, 100);
  }

  // Initialize complementary products functionality
  initComplementaryProducts() {
    const complementaryContainer = document.querySelector('.custom-cart__complementary-products');
    const wrapper = document.querySelector('.horizontal-products');
    const progressBar = document.querySelector('.complementary-products__progress');
    const progressFill = document.querySelector('.complementary-products__progress-fill');
    
    // console.log('Initializing complementary products:', {
    //   container: complementaryContainer,
    //   wrapper: wrapper,
    //   progressBar: progressBar,
    //   progressFill: progressFill
    // });
    
    if (wrapper && progressFill) {
      this.setupScrollProgress(wrapper);
    } else {
      console.log('Complementary products initialization failed - missing required elements');
    }
  }

  onCartError(errors, target) {
    if (target) {
      this.updateQuantity(target.getAttribute('data-index'), target.defaultValue, document.activeElement.getAttribute('name'), target);
    }
    else {
      window.location.href = theme.routes.cart_url;
    }

    alert(errors);
  }

  updateQuantity(line, quantity, name, target) {
    this.enableLoading(line);

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

    const body = JSON.stringify({
      id: line,
      quantity,
      sections: sectionsToBundle
    });

    fetch(`${theme.routes.cart_change_url}`, { ...theme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cart: parsedState, target, line, name });
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted by user');
        }
        else {
          console.error(error);
        }
      });
  }

  enableLoading(line) {
    const loader = document.getElementById(`Loader-${this.sectionId}-${line}`);
    if (loader) loader.hidden = false;
  }

  setValidity(target, message) {
    target.setCustomValidity(message);
    target.reportValidity();
    target.value = target.defaultValue;
    target.select();
  }

  validateQuantity(event) {
    const target = event.target;
    const inputValue = parseInt(target.value);
    const index = target.getAttribute('data-index');
    let message = '';

    if (inputValue < parseInt(target.getAttribute('data-min'))) {
      message = theme.quickOrderListStrings.min_error.replace('[min]', target.getAttribute('data-min'));
    }
    else if (inputValue > parseInt(target.max)) {
      message = theme.quickOrderListStrings.max_error.replace('[max]', target.max);
    }
    else if (inputValue % parseInt(target.step) !== 0) {
      message = theme.quickOrderListStrings.step_error.replace('[step]', target.step);
    }

    if (message) {
      this.setValidity(target, message);
    }
    else {
      target.setCustomValidity('');
      target.reportValidity();
      this.updateQuantity(index, inputValue, document.activeElement.getAttribute('name'), target);
    }
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', theme.utils.debounce(this.onChange.bind(this), 300));
  }

  onChange(event) {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${theme.routes.cart_update_url}`, { ...theme.utils.fetchConfig(), ...{ body } });
  }
}
customElements.define('cart-note', CartNote);

class MainCart extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('cart:bundled-sections', this.onPrepareBundledSections.bind(this));
  }

  onPrepareBundledSections(event) {
    event.detail.sections.push(theme.utils.sectionId(this));
  }
}
customElements.define('main-cart', MainCart);

class CountryProvince extends HTMLElement {
  constructor() {
    super();

    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.countryElement.addEventListener('change', this.handleCountryChange.bind(this));

    if (this.getAttribute('country') !== '') {
      this.countryElement.selectedIndex = Math.max(0, Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.getAttribute('data-country')));
      this.countryElement.dispatchEvent(new Event('change'));
    }
    else {
      this.handleCountryChange();
    }
  }

  handleCountryChange() {
    const option = this.countryElement.options[this.countryElement.selectedIndex], provinces = JSON.parse(option.getAttribute('data-provinces'));
    this.provinceElement.parentElement.hidden = provinces.length === 0;

    if (provinces.length === 0) {
      return;
    }

    this.provinceElement.innerHTML = '';

    provinces.forEach((data) => {
      const selected = data[1] === this.getAttribute('data-province');
      this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
    });
  }
}
customElements.define('country-province', CountryProvince);

class ShippingCalculator extends HTMLFormElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;

    this.submitButton.addEventListener('click', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(event) {
    event.preventDefault();

    this.abortController?.abort();
    this.abortController = new AbortController();

    const zip = this.querySelector('[name="address[zip]"]').value,
      country = this.querySelector('[name="address[country]"]').value,
      province = this.querySelector('[name="address[province]"]').value;

    this.submitButton.setAttribute('aria-busy', 'true');

    const body = JSON.stringify({
      shipping_address: { zip, country, province }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...theme.utils.fetchConfig('javascript'), ...{ body }, signal: this.abortController.signal })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.formatShippingRates(parsedState.shipping_rates);
        }
        else {
          this.formatError(parsedState);
        }
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted by user');
        }
        else {
          console.error(error);
        }
      })
      .finally(() => {
        this.resultsElement.hidden = false;
        this.submitButton.removeAttribute('aria-busy');
      });

  }

  formatError(errors) {
    const shippingRatesList = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert alert--error grid gap-2 text-sm leading-tight">
        <p>${theme.shippingCalculatorStrings.error}</p>
        <ul class="list-disc grid gap-2" role="list">${shippingRatesList.join('')}</ul>
      </div>
    `;
  }

  formatShippingRates(shippingRates) {
    const shippingRatesList = shippingRates.map(({ presentment_name, currency, price }) => {
      return `<li>${presentment_name}: ${currency} ${price}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert alert--${shippingRates.length === 0 ? 'error' : 'success'} grid gap-2 text-sm leading-tight">
        <p>${shippingRates.length === 0 ? theme.shippingCalculatorStrings.notFound : shippingRates.length === 1 ? theme.shippingCalculatorStrings.oneResult : theme.shippingCalculatorStrings.multipleResults}</p>
        ${shippingRatesList === '' ? '' : `<ul class="list-disc grid gap-2" role="list">${shippingRatesList.join('')}</ul>`}
      </div>
    `;

  }
}
customElements.define('shipping-calculator', ShippingCalculator, { extends: 'form' });
